import { render, staticRenderFns } from "./SingleValueViewer.vue?vue&type=template&id=87d1db62"
import script from "./SingleValueViewer.vue?vue&type=script&lang=js"
export * from "./SingleValueViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports